import { ReactNode } from "react";

import { Column, MEDIA, OutlinedCard, Text } from "@bridgesplit/ui";
import { useMediaQuery } from "@mui/material";

export function PageSubtitle({ children }: { children: ReactNode }) {
    return <Text variant="h3"> {children} </Text>;
}

interface PageTitleProps {
    title: string;
    description?: string;
}

export function PageTitle({ title, description }: PageTitleProps) {
    return (
        <Column spacing={1}>
            <Text variant="h1">{title} </Text>
            {description && <Text color="caption">{description}</Text>}
        </Column>
    );
}

export function TableCardWrapper({ children, flushOnMobile }: { children: ReactNode; flushOnMobile?: boolean }) {
    const isMobile = useMediaQuery(MEDIA.SM.below);
    const flush = !!flushOnMobile && isMobile;
    return (
        <OutlinedCard spacing={2} padding={flush ? 0 : 2} hideCard={flush} hideBorder={flush}>
            {children}
        </OutlinedCard>
    );
}
